
import type { MetaInfo } from "vue-meta"
import paginationMixin from "@/mixins/pagination"
import type { PhotoGroup } from "@/types/api/photo"
import type { Tag } from "@/types/api/tag"

export default paginationMixin.extend({
  layoutSettings: {
    titleToken: "photobank",
  },

  // validate ({ store }) {
  //   return store.getters["user/isAdmin"]
  // },

  head (): MetaInfo {
    return {
      title: this.$store.getters["app/getTitle"](this.eventTitle),
    }
  },

  data: () => ({
    tags: [] as Tag[],
    groups: [] as PhotoGroup[],
  }),

  async fetch () {
    await this.fetchGroups()
  },

  computed: {
    eventTitle (): string {
      return this.groups[0]?.photoEvent?.event?.title?.current || ""
    },

    breadcrumbs (): Record<string, string> {
      const breadcrumbs: Record<string, string> = {
        "/": "homepage",
        "/photo": "photobank",
      }

      const { eventAlias } = this.$route.params
      const { eventTitle } = this
      if (eventTitle)
        breadcrumbs[`/photo/${eventAlias}`] = eventTitle

      return breadcrumbs
    },

    tagsOpts (): Record<string, string> {
      return Object.fromEntries(
        this.tags.map(t => [t.title.current, t.id]),
      )
    },

    date: {
      get (): string {
        return this.$route.query.date as string || ""
      },
      set (date?: string) {
        date = (date || "").split("T")[0]

        this.$router.push({
          query: {
            ...this.$route.query,
            date: date || undefined,
          },
        })
      },
    },

    tag: {
      get (): string {
        return this.$route.query.tag as string || ""
      },
      set (tag: string) {
        this.$router.push({
          query: {
            ...this.$route.query,
            tag: tag || undefined,
          },
        })
      },
    },
  },

  watch: {
    date: "onFilterChange",
    tag: "onFilterChange",
  },

  mounted () {
    this.fetchTags()

    this.$watch("page", async () => {
      this.scrollToTop()
      await this.fetchGroups()
    })
  },

  methods: {
    onFilterChange () {
      if (this.page === 1)
        this.fetchGroups()
      else
        this.page = 1
    },

    async fetchGroups () {
      const filters = [
        {
          name: "photoEvent.event.alias",
          value: this.$route.params.eventAlias,
        },
      ]
      if (this.date)
        filters.push({ name: "date", value: this.date })
      if (this.tag)
        filters.push({ name: "tags.id", value: this.tag })

      const [res, err] = await this.$api.photo.listPhotoGroup(
        filters,
        this.page,
        {
          params: {
            event: this.$config.event,
          },
        },
      )

      if (err) {
        this.error = err.message
        return
      }

      const pages = res?.pagination?.pages || 1

      if (this.page > pages) {
        this.page = pages
        await this.fetchGroups()
        return
      }

      this.groups = res?.items || []
      this.pages = pages
    },

    async fetchTags () {
      const [res, err] = await this.$api.tag.getTags([{
        name: "group.alias",
        value: "photo",
      }])

      if (err)
        console.error(err)

      this.tags = res?.items || []
    },
  },
})
